<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";

export default {
  name: "ErrorOverlay",
  mixins: [GeneralMixin],
  inject: {
    eventsBus: { from: "eventsBus" }
  },
  props: {
    campaignRestrictedMessage: {
      required: true,
      type: Object
    }
  },
  computed: {
    open() {
      return this.error && this.errorModalOpen;
    },
    error() {
      let error = null;

      if (this.campaignRestrictionsError && this.campaignRestrictedMessage) {
        const body = this.campaignRestrictedMessage.restrictedMessageBody;
        const ending = this.campaignRestrictedMessage.restrictedMessageEnding;

        error = `${body} ${ending}`;
      } else if (this.legislatorsErrorMessage) {
        error = this.legislatorsErrorMessage;
      } else if (this.actionError) {
        error = this.actionError;
      }

      return error;
    },
    showSkipAction() {
      return (
        this.currentAction === "twitter" &&
        this.currentActionCard &&
        this.numberOfIncompletedActions > 1
      );
    }
  },
  methods: {
    skipAction() {
      this.eventsBus.$emit("skipAction");
    }
  }
};
</script>
